import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormViewService, JsonbType } from '@xilo-mono/form-contracts';
import { ReplaySubject, takeUntil } from 'rxjs';
import { CustomerFormFacade } from '../../+state/customer-form/customer-form.facade';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'xilo-mono-form-viewer-selectbox',
  templateUrl: './selectbox.component.html',
  styleUrls: ['./selectbox.component.scss', '../../form-viewer.component.scss'],
})
export class CustomSelectboxComponent extends FieldType implements OnInit, OnDestroy {
  public selectOptionList: Array<string> = [];
  subsection = 0;
  isRepeatAddAnother = false;
  private readonly destroyed$ = new ReplaySubject<boolean>(1);
  companyId:string
  clientId:number
  linkLoading: boolean;
  selectedItem;

  public get isMultipleSelect() {
    return this.to?.isMultipleSelect;
  }

  constructor(
    private customerFormFacade: CustomerFormFacade,
    private formViewService: FormViewService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    const initialValue = this.formControl.value;
    this.selectOptionList = this.isMultipleSelect && initialValue ? initialValue : [];

    this.formControl.valueChanges.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((value) => {
      if (this.isMultipleSelect && value) {
        this.selectOptionList = value;
      }
    });
    this.isRepeatAddAnother = this.to.repeatAddAnother;
    this.customerFormFacade.subsectionIndex$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((index) => {
      this.subsection = index;
    });
  }

  ngOnDestroy() {
    if (this.isRepeatAddAnother) {
      this.formControl.setValue('answered');
    }
    this.destroyed$.next(true);
  }

  getValue(): string {
    return this.formControl?.value;
  }

  handleOptionSelect(item) {
    if (item?.triggerCarrierUrl) {
      this.linkLoading  = true
      this.selectedItem = item
      this.route.queryParams.pipe(
        takeUntil(this.destroyed$)
      ).subscribe((queryParams) => {
        this.clientId = +queryParams.clientId
        this.companyId = queryParams.companyId
      })
      // Open insurGrid and continue on through form
      this.formViewService.addInsurgridClient(this.companyId, this.clientId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (body:JsonbType) => {
            window.open(body.url, '_blank');
            this.linkLoading = false;
            this.gotoNext();
            // Log carrier opened event
            this.formViewService.logEvent({
              name: 'insurGrid:carrier_opened',
              result: 'ok',
              objId: this.clientId.toString(),
              occurredAt: new Date(),
              ip: '',
            }).pipe(
              takeUntil(this.destroyed$)
            ).subscribe()
          },
          error: (error: Error) => {
            this.linkLoading = false;
            console.log('### ERROR: ', error);
          },
        });
    }
    if (this.isRepeatAddAnother) {
      this.formControl.patchValue(item.value);
      if (item.value) {
        // Repeat this section
        setTimeout(() => {
          this.customerFormFacade.triggerAddRepeatSection();
        }, 500);
      } else {
        // Go to next question
        this.gotoNext();
      }
    } else if (!this.isMultipleSelect) {
      if (this.to?.dataPullMappingId && item.value === 'true') {
        this.formControl.patchValue(true);
        this.formControl.markAsDirty();
      } else {
        this.formControl.patchValue(item.value);
        this.formControl.markAsDirty();
        this.gotoNext();
      }
    } else if (this.isMultipleSelect) {
      if (!this.selectOptionList.includes(item.value)) {
        this.selectOptionList.push(item.value);
      } else {
        if (this.selectOptionList.includes(item.value)) {
          this.selectOptionList.splice(
            this.selectOptionList.indexOf(item.value),
            1
          );
        }
      }
      this.formControl.patchValue(this.selectOptionList);
      this.formControl.markAsDirty();
    }
    if (this.to.className !== 'xilo-input') {
      this.formViewService.updateForm.next(true);
    }
  }

  isSelectedOption(data): boolean {
    return this.selectOptionList.includes(data);
  }

  gotoNext() {
    if (!this.linkLoading) {
      setTimeout(() => {
          this.customerFormFacade.next();
      }, 500);
    }
  }

  handleTooltipClick($event) {
    $event.preventDefault();
    $event.stopPropagation();
  }
}
